import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import { FilterDeviceName } from 'common/filters/index';
import Util from 'common/services/util/-RFC.util';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

/**
* @ngdoc service
* @name notifications.DeviceNotifications
*
* @description
* This class is used to process notifications on devices.
*/
const DeviceNotifications = {

    /**
     * @ngdoc function
     * @name notifications.DeviceNotifications#processUpdate
     * @methodOf notifications.DeviceNotifications
     * @function
     *
     * @description
     * This function can be used to process updates made on a device.
     *
     * @param {object} data An object with updated values on device.
     * @param {object} prevDevice The old device object.
     * @param {object} newDevice The update device object.
     */
    processUpdate(data, prevDevice, newDevice) {

        // hide notifications if not in dashboard
        if (this._hideNotifications()) {

            return;

        }

        // Device renamed
        if (data['attributes.alias'] || data['attributes.name']) {

            const prevName = FilterDeviceName(prevDevice);
            const newName = FilterDeviceName(newDevice);
            Alert.success(
                {
                    message: 'cw.device.rename.success',
                    icon: {
                        cssClasses: `icon-${Util.deepFind(newDevice, 'attributes.type')}`,
                    },
                },
                {
                    message: {
                        devicePrevName: prevName,
                        deviceNewName: newName,
                    },
                },
            );

        }

        // Device removed
        if (data['attributes.hidden'] === 'true') {

            Alert.success(
                {
                    message: 'cw.device.remove.success',
                    icon: {
                        cssClasses: `icon-${Util.deepFind(newDevice, 'attributes.type')}`,
                    },
                },
                {
                    message: {
                        deviceName: FilterDeviceName(newDevice),
                    },
                },
            );

        }

        // Device reactivated
        if (data['attributes.hidden'] === 'false') {

            Alert.success(
                {
                    message: 'cw.device.reactivate.success',
                    icon: {
                        cssClasses: `icon-${Util.deepFind(newDevice, 'attributes.type')}`,
                    },
                },
                {
                    message: {
                        deviceName: FilterDeviceName(newDevice),
                    },
                },
            );

        }

        // Device changed state to online/offline from pending
        if (data['attributes.state']) {

            if (prevDevice.attributes.state === 'pending') {

                this._sendMixpanelForNewDevice(newDevice);

            }

        }

    },

    /**
     * @ngdoc function
     * @name notifications.DeviceNotifications#processCreate
     * @methodOf notifications.DeviceNotifications
     * @function
     *
     * @description
     * This function can be used to process the creation of a device.
     *
     * @param {object} device An object with the new device.
     */
    processCreate(device) {

        // hide notifications if not in dashboard
        if (this._hideNotifications()) {

            return;

        }

        if (Util.deepFind(device, 'attributes.state') !== 'pending') {

            const stateParams = `resourceId:${
                device.id},tab:apps`;
            const deviceName = FilterDeviceName(device);
            const deviceLink = `<b><a stateTo='root.dashboard.device-details' stateparams='${stateParams}'>${deviceName}</a></b>`;

            // a new non-pending device is added
            Alert.success(
                {
                    message: 'cw.device.add.success',
                    icon: {
                        cssClasses: `icon-${Util.deepFind(device, 'attributes.type')}`,
                    },
                },
                {
                    message: {
                        deviceName: deviceLink,
                    },
                },
            );

            this._sendMixpanelForNewDevice(device);

        }

    },

    _sendMixpanelForNewDevice(newDevice) {

        Mixpanel.send('Connect Web Alert Triggered', {
            'Alert Type': 'Success',
            'Alert Name': `${FilterDeviceName(newDevice)} Added`,
        });

    },

    _hideNotifications() {

        return window.location.pathname.indexOf('dashboard') === -1;

    },

};

export default DeviceNotifications;



// WEBPACK FOOTER //
// ./scripts/common/notifications/-RFC.deviceNotifications.js